import { createContext, useContext } from "react";

export interface TourApi {
  /** Reset the seen flag and start the welcome card (the Settings replay). */
  startTour: () => void;
  /** Leave the demo (marks it seen, returns to /overview). */
  exitDemo: () => void;
}

export const TourContext = createContext<TourApi | null>(null);

export function useTour(): TourApi {
  const ctx = useContext(TourContext);
  if (!ctx) throw new Error("useTour must be used within TourProvider");
  return ctx;
}
